import { render, staticRenderFns } from "./ForgotPasswordVerifyEmail.vue?vue&type=template&id=5e360ec2&scoped=true&"
import script from "./ForgotPasswordVerifyEmail.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordVerifyEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e360ec2",
  null
  
)

export default component.exports